import { styled } from '@mui/material';

export const Section = styled('section')({
    padding: '32px',
    width: '100%',
    justifySelf: 'center',
    boxSizing: 'border-box',
    overflowX: 'hidden',
});
